import { isBrowser } from 'utils/misc-utils';
import type { Fides } from '../types';

export const getFides = (): Fides | undefined => (!isBrowser() ? undefined : global.window.Fides);
